/**
 * Autogenerated file don't modify
 */
(function () {
(function () {
    'use strict';

    var util = MoyaContainer.get('core.util');
    MoyaComponents.register('extras.employee-toggle', function (el) {
        var toggler = new EmployeeToggle(el);
        toggler.run();
    });
    var EmployeeToggle = /** @class */ (function () {
        function EmployeeToggle(el) {
            this.el = el;
        }
        EmployeeToggle.prototype.run = function () {
            var _this = this;
            util.delegate(this.el, 'click', 'button', function () {
                _this.el.querySelector('.toggleBar').dispatchEvent(new Event('click'));
            });
        };
        return EmployeeToggle;
    }());

}());
typeof tsBuild === 'function' && tsBuild();})();
